import React from "react";
import Button from "../../common/button/button";
import DateFormat from "../../common/dateFormat/DateFormat";
import { ModalAlert } from "../../common/dialog/modalAlert";
import { adicionarPontosMilhar } from "../../utils/adicionarPontosMilhar";
import { validarTarifaMediaLiquida } from "../../core/validarTarifaMediaLiquida";

export function getMensagensErro(item) {
    const apenasMercadoLivreImportado =
        !item.arquivo_pdf &&
        (item.arquivo_pdf_custo_energia_acl_cp || item.arquivo_pdf_custo_energia_acl_lp || item.arquivo_pdf_custo_gestao_acl || item.arquivo_pdf_contribuicao_associativa_ccee);

    //ignora aviso de fatura isenta, pois passou a ser listado como alerta, e não como erro
    const errosImportacao = (item.erros_importacao || []).filter((erro) => erro.tipo !== "Fatura Isenta").map((erro) => erro.mensagem);

    const listaMensagensErroImportacaoHtml = (
        <ul style={{ minWidth: 150, paddingLeft: 20 }}>
            {errosImportacao.map((erro) => (
                <li key={erro}> {erro}</li>
            ))}
        </ul>
    );
    const listaMensagensErroImportacaoText = errosImportacao.join("  |  ");

    const temErros = errosImportacao.length;
    const msgErroImportacaoHtml = item.importacao_validada ? (
        !temErros || item.fatura_isenta ? (
            "Validado"
        ) : (
            <div style={{ fontSize: "0.8rem !important" }}>Verifique:{listaMensagensErroImportacaoHtml}</div>
        )
    ) : item.importado || item.arquivo_pdf ? (
        !temErros ? (
            apenasMercadoLivreImportado ? (
                "Mercado Livre Importado"
            ) : (
                "Importado"
            )
        ) : (
            <div style={{ fontSize: "0.8rem !important" }}>Verifique:{listaMensagensErroImportacaoHtml}</div>
        )
    ) : (
        "Não Importado"
    );
    const msgErroImportacaoText = item.importacao_validada
        ? !temErros || item.fatura_isenta
            ? "Validado"
            : `Verifique: ${listaMensagensErroImportacaoText}`
        : item.importado || item.arquivo_pdf
          ? !temErros
              ? apenasMercadoLivreImportado
                  ? "Mercado Livre Importado"
                  : "Importado"
              : `Verifique: ${listaMensagensErroImportacaoText}`
          : "Não Importado";
    return { msgErroImportacaoHtml, msgErroImportacaoText };
}

export function getMensagensAlerta({
    item,
    somenteOportunidade = false,
    listaUsuarioAdministrador,
    alertaAlterando,
    onAlterarStatusAlerta,
    onMarcarTodos,
    onReprocessarIsenta,
    onClose,
}) {
    const alertasPersistidos = somenteOportunidade ? item.alertas_oportunidade || [] : item.alertas || [];
    //todos alertas e o aviso de TML sao não bloqueantes
    const errosAlertas = alertasPersistidos.map((alerta) => alerta.mensagem);
    if (!somenteOportunidade && !validarTarifaMediaLiquida(item.tarifa_media_liquida)) {
        errosAlertas.push("TML maior que R$ 6, verifique os valores destacados");
    }
    if (!somenteOportunidade && !item.unidade_geradora && !item.unidade_remota && item.saldo_geracao > 0) {
        errosAlertas.push(`UC não é geradora e nem remota, porém consta o saldo de ${adicionarPontosMilhar(item.saldo_geracao)}`);
    }

    //tratar mensagem fatura isenta quando veio na lisa de erros_importação, senão já vai ta na lista
    if (!somenteOportunidade && item.fatura_isenta && !alertasPersistidos.find((alerta) => alerta.tipo === "Fatura Isenta")) {
        errosAlertas.push("Fatura Isenta - valor da fatura será inserido em cobrança futura");
    }
    const listaRevisada = alertasPersistidos.length > 0 && alertasPersistidos.every((alerta) => alerta.verificado);

    // Para Coelba, desabilita o botão de revisão somente quando houver alerta de Fatura Isenta
    // Após selecionar Sim ou Não, o botão de revisão é liberado/habilitado.
    const concCoelba = item.id_concessionaria === 11;
    const temAlertaFaturaIsenta = errosAlertas.some((alerta) => typeof alerta === "string" && alerta.includes("Fatura Isenta"));
    const jaDecidiuIsenta = item.considerar_isenta_analise === true || item.considerar_isenta_analise === false;
    const precisaDecidirIsenta = concCoelba && temAlertaFaturaIsenta && !jaDecidiuIsenta;
    const habilitaMarcarRevisado = !precisaDecidirIsenta;

    const estiloCelulaAlerta = {
        border: "1px solid #d9d9d9",
        padding: "8px 10px",
        verticalAlign: "middle",
        textAlign: "left",
    };
    const estiloCabecalhoAlerta = {
        ...estiloCelulaAlerta,
        backgroundColor: "#f4f6f8",
        fontWeight: 700,
        whiteSpace: "nowrap",
    };

    const listaMensagensAlertaImportacaoHtml = (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85rem", minWidth: 760 }}>
            <thead>
                <tr>
                    <th style={estiloCabecalhoAlerta}>Status</th>
                    <th style={estiloCabecalhoAlerta}>Analista</th>
                    <th style={{ ...estiloCabecalhoAlerta, whiteSpace: "nowrap" }}>Data/Hora</th>
                    <th style={estiloCabecalhoAlerta}>Mensagem</th>
                </tr>
            </thead>
            <tbody>
                {errosAlertas.map((alerta) => {
                    const objCompleto = alertasPersistidos.find((al) => al.mensagem === alerta) || {};
                    const alertaPersistido = !!(objCompleto.tipo && objCompleto.mensagem);
                    const verificado = alertaPersistido ? !!objCompleto.verificado : listaRevisada;
                    const usuarioResponsavelAlerta = (listaUsuarioAdministrador || []).find((usuario) => usuario.id == objCompleto.id_usuario_responsavel);
                    const isFaturaIsentaCoelba = concCoelba && typeof alerta === "string" && alerta.includes("Fatura Isenta");
                    const mostrarBotoesIsenta = isFaturaIsentaCoelba && !listaRevisada && !jaDecidiuIsenta;
                    return (
                        <tr key={alerta}>
                            <td style={{ ...estiloCelulaAlerta, textAlign: "center", width: 120 }}>
                                {alertaPersistido ? (
                                    <button
                                        type="button"
                                        className="pill-status-alerta"
                                        disabled={!!alertaAlterando}
                                        title={verificado ? "Clique para marcar como pendente" : "Clique para marcar como verificado"}
                                        onClick={() => onAlterarStatusAlerta(item, objCompleto, !verificado)}
                                        style={{
                                            border: "none",
                                            borderRadius: 999,
                                            padding: "4px 12px",
                                            fontSize: "0.75rem",
                                            fontWeight: 700,
                                            color: "#fff",
                                            backgroundColor: verificado ? "#28a745" : "#dc3545",
                                            cursor: alertaAlterando ? "wait" : "pointer",
                                            whiteSpace: "nowrap",
                                            transition: "filter 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease",
                                        }}
                                    >
                                        {verificado ? "Verificado" : "Pendente"}
                                    </button>
                                ) : (
                                    <span
                                        style={{
                                            display: "inline-block",
                                            borderRadius: 999,
                                            padding: "4px 12px",
                                            fontSize: "0.75rem",
                                            fontWeight: 700,
                                            color: "#fff",
                                            backgroundColor: verificado ? "#28a745" : "#dc3545",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {verificado ? "Verificado" : "Pendente"}
                                    </span>
                                )}
                            </td>
                            <td style={{ ...estiloCelulaAlerta, whiteSpace: "nowrap" }}>{usuarioResponsavelAlerta ? usuarioResponsavelAlerta.valor : "—"}</td>
                            <td style={{ ...estiloCelulaAlerta, whiteSpace: "nowrap" }}>
                                {(DateFormat.formatarDataHoraSqlParaTela(objCompleto.datahora_alteracao || objCompleto.datahora_verificacao, { showSeconds: true }) || "—").replace(
                                    " ",
                                    " às "
                                )}
                            </td>
                            <td style={estiloCelulaAlerta}>
                                <div>{alerta}</div>
                                {objCompleto.link ? (
                                    <div>
                                        Acesse em:{" "}
                                        <a href={objCompleto.link} target="_blank" rel="noopener noreferrer">
                                            {objCompleto.link}
                                        </a>
                                    </div>
                                ) : null}
                                {mostrarBotoesIsenta ? (
                                    <div style={{ marginTop: 10, display: "flex", gap: 8, justifyContent: "center", flexWrap: "wrap" }}>
                                        <Button
                                            text="Sim (Isenta e não soma custos nos gráficos de análises)"
                                            type={"success"}
                                            icon={"fa fa-check"}
                                            style={{ marginTop: 5 }}
                                            event={() => {
                                                onReprocessarIsenta(item.id, true);
                                                onClose();
                                            }}
                                        />
                                        <Button
                                            text="Não (Não isenta e o custo será somado nos gráficos de análise)"
                                            type={"danger"}
                                            icon={"fa fa-times"}
                                            style={{ marginTop: 5 }}
                                            event={() => {
                                                onReprocessarIsenta(item.id, false);
                                                onClose();
                                            }}
                                        />
                                    </div>
                                ) : null}
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
    const listaMensagensAlertaImportacaoText = errosAlertas.join("  |  ");

    const temAlertas = errosAlertas.length;
    const msgAlertaImportacaoHtml =
        item.importado && temAlertas ? (
            <div>
                <div style={{ fontSize: "0.85rem", overflowX: "auto" }}>{listaMensagensAlertaImportacaoHtml}</div>
                <Button
                    text={listaRevisada ? "Marcar todos como Pendentes" : "Marcar todos como Verificados"}
                    type={listaRevisada ? "danger" : "success"}
                    icon={listaRevisada ? "fa fa-times" : "fa fa-check"}
                    style={{ marginTop: 20 }}
                    disabled={!listaRevisada && !habilitaMarcarRevisado}
                    event={() => onMarcarTodos(item, { oportunidade_rc: somenteOportunidade })}
                />
            </div>
        ) : null;
    const msgAlertaImportacaoText = item.importado && temAlertas ? `Verifique: ${listaMensagensAlertaImportacaoText}` : "";

    return { msgAlertaImportacaoHtml, msgAlertaImportacaoText };
}

export function ModalAlertasErrosFatura({
    showModal,
    idFatura,
    conteudoErros,
    lista,
    listaUsuarioAdministrador,
    alertaAlterando,
    somenteOportunidade = false,
    onClose,
    onAlterarStatusAlerta,
    onMarcarTodos,
    onReprocessarIsenta,
}) {
    let conteudo = conteudoErros;
    if (idFatura) {
        const item = (lista || []).find((fatura) => fatura.id == idFatura);
        conteudo = item
            ? getMensagensAlerta({
                  item,
                  somenteOportunidade,
                  listaUsuarioAdministrador,
                  alertaAlterando,
                  onAlterarStatusAlerta,
                  onMarcarTodos,
                  onReprocessarIsenta,
                  onClose,
              }).msgAlertaImportacaoHtml
            : null;
    }

    return (
        <ModalAlert showModal={showModal} titulo="" handleClose={onClose} maxWidth={idFatura ? 1100 : 1000}>
            {conteudo}
        </ModalAlert>
    );
}
